import React, { useState } from "react";
import Style from "./OurWork.module.css";
import Theme from "../../theme.module.css";
import Content from "../../layouts/Content";
import CaseStudyGridSingle from "./CaseStudyGridSingle";
import Modal from "../../layouts/Modal";
import './CaseStudyMain.css';


export default function OurWork({modalOpen, setModalOpen}) {

    const [caseStudy, setCaseStudy] = useState('');

    return (
        <section className={`${Theme.section} ${Theme.dark} ${Style.ourWork}`} >
            <h1 className={Theme.sectionTitle}>Our Work</h1>
            <Content>
                <p className={Style.subtitle}>Learn about some of the solutions we have implemented for our clients and partners</p>
                <div className={Style.caseStudyGrid}>
                    <div className={Style.paddingTop}></div>
                    <div className={`${Style.inner} animateColumns`}>
                        <div>
                            <CaseStudyGridSingle 
                                img={require('../../assets/raceworks-img-1.jpg')} 
                                title={'The Raceworks ecommerce Internationalisation'} 
                                slug={'the-raceworks-internationalisation'} 
                                desc={'We helped The Raceworks to expand their business internationally with a headless WooCommerce solution, with custom localisation features, translation services, automated delivery pipeline and more.'} 
                                setModalOpen={setModalOpen}
                                classNames={'full-height'}
                            />
                        </div>
                        <div className={Style.rightCol}>
                            <CaseStudyGridSingle 
                                img={require('../../assets/abrfest-2.jpg')} 
                                title={'ABR Festival'} 
                                slug={'abr-festival'} 
                                desc={''} 
                                setModalOpen={setModalOpen}
                                classNames={'half-height'}
                            />
                            <CaseStudyGridSingle 
                                img={require('../../assets/odyssey-media-2.jpg')} 
                                title={'Odyssey Media - Ecommerce Client'} 
                                slug={'odyssey-media-bed'} 
                                desc={''} 
                                setModalOpen={setModalOpen}
                                classNames={'half-height'}
                            />
                        </div>
                    </div>
                </div>
                <div className={Style.clientsPartners}>
                    <h2 className={Style.clientsTitle}>Our clients & partners</h2>
                    <div className={Style.logoCont}>
                        <img src={require('../../assets/Gocardless-blue.svg').default} alt="gocardless-logo" />
                        <img src={require('../../assets/evince-160-@2x.png')} alt="evince-logo" />
                        <img src={require('../../assets/context-consulting-logo.png')} alt="context-consulting-logo" />
                        <img src={require('../../assets/abr-logo.png')} alt="abr-festival-logo" />
                        <img src={require('../../assets/theraceworks-logo.png')} alt="the-raceworks-logo" />
                        <img src={require('../../assets/odyssey-media-logo.svg').default} alt="odyssey-media-logo" />
                        <img src={require('../../assets/rrd.png')} alt="rubber-roofing-direct-logo" />
                    </div>
                </div>
            </Content>
        </section>
    );
}